/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { useContext, useEffect, useState } from "react";
import { useComponentPositionContext } from "cms/components/context/component-position.context/use-component-position-context";
import { ContentZoneContext } from "cms/components/context/index";
import { UpDownButtons } from "cms/components/layout/sortable/up-down-buttons";
// import { useContentZone } from 'cms/components/hooks/use-content-zone'
import { Logger } from "cms/utils/log/logger";

const ComponentPositionButtons = () => {
    
    const {
        component,
        count,
        index: _index,
    } = useContext(ContentZoneContext);
    
    const { move } = useComponentPositionContext();
    const { guid } = component || {};

    // const [position, setPosition] = useState(propsPosition)
    const [index, setIndex] = useState(_index);
    
    useEffect(() => {
        setIndex(_index);
    }, [_index]);
    
    const last_index = count - 1;
    const isSingle = count === 1;
    const isFirst = (index === 0) && !isSingle;
    const isLast = (index === last_index) && !isSingle;

    const moveUp = (event) => {
        event.stopPropagation();
        Logger.debug("moveUp");
        move("up", guid, index);
    };
    const moveDown = (event) => {
        event.stopPropagation();
        Logger.debug("moveDown");
        move("down", guid, index);
    };
    const noMove = (event) => {
        event.stopPropagation();
    };
    
    const defaultProps = {
        handleUp: moveUp,
        handleDown: moveDown,
    };

    const firstProps = { ...defaultProps, handleUp: noMove, upDisabled: true };
    const lastProps = { ...defaultProps, handleDown: noMove, downDisabled: true };

    const activeProps = isFirst ? firstProps : isLast ? lastProps : defaultProps;
    
    return (
        <UpDownButtons {...activeProps} />
    );
};

ComponentPositionButtons.displayName = "ComponentPositionButtons";
export { ComponentPositionButtons };
